import React from "react";
import ReactECharts from "echarts-for-react";
import ChartEmptyState from "./ChartEmptyState";

class StackedBarChartTemplate2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startIndex: 0,
    };
  }

  getRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  getOption = (stackData, xAxisData, seriesData, xAxisName, barColors) => {
    let opt = {
      legend: {
        data: stackData ? stackData : [],
        orient: "horizontal",
        right: 57,
        top: 2,
      },
      tooltip: {
        trigger: "item",
        position: "right"       
      },
      xAxis: {
        data: xAxisData,
        name: xAxisName,
        nameLocation: "middle",
        nameGap: 66,
        nameTextStyle: {
          color: "#333",
          fontSize: 14,
          fontWeight: 500,
        },
        axisLabel: {
          show: true,
          interval: 0,
          fontSize: 11,
          lineHeight: 16,
          width: 120,
          overflow: "break",
        },
        axisLine: { onZero: true },
        splitLine: { show: false },
        splitArea: { show: false },
      },
      yAxis: {
        axisLabel: {
          formatter: (value) => this.formatNumber(value),
        },
      },
      ...(xAxisData.length > 4 && {
        dataZoom: [
          {
            type: "inside",
            zoomLock: true,
            zoomOnMouseWheel: false,
            moveOnMouseMove: false,
            moveOnMouseWheel: false,
            startValue: this.state.startIndex,
            endValue: this.state.startIndex + 3 - 1,
          },
        ],
      }),
      grid: {
        left: 40,
        bottom: 100,
      },
      series: seriesData ? seriesData : [],
    };
    if(barColors){
      opt['color'] = barColors.split(',')
    }
    return opt;
  };

  next(xAxisData) {
    if (this.state.startIndex < xAxisData.length - 3) {
      this.setState({ startIndex: this.state.startIndex + 3 });
    }
  }

  formatNumber(value) {
    const absValue = Math.abs(value);
    if (absValue >= 1e9)
      return (value / 1e9).toFixed(1).replace(".0", "") + "B";
    if (absValue >= 1e6)
      return (value / 1e6).toFixed(1).replace(".0", "") + "M";
    if (absValue >= 1e3)
      return (value / 1e3).toFixed(1).replace(".0", "") + "K";
    return value;
  }

  prev() {
    if (this.state.startIndex > 0) {
      this.setState({ startIndex: this.state.startIndex - 3 });
    }
  }

  isPrime(num) {
    if (num < 2) return false;
    for (let i = 2; i <= Math.sqrt(num); i++) {
      if (num % i === 0) {
        return false;
      }
    }
    return true;
  }

  render() {
    const { graphData, barChartConfig, graphHeight } = this.props;
    const stacked = barChartConfig.yAxis ? barChartConfig.yAxis.split(",") : [];

    let xAxisData = [];
    let seriesData = [];
    let nestedSeriesData = [];

    graphData &&
      graphData.map((g, i) => {
        let tmp = {};
        for (const key in g.tableData) {
          tmp[key.trim()] = g.tableData[key];
          if (key.trim() !== barChartConfig.xAxis) {
            const filterKey = graphData.map((el) => el.tableData[key]);
            if (stacked.length - 1 === i || graphData.length === 1) {
              nestedSeriesData.push(filterKey);
            }
          }
        }
        xAxisData.push(tmp[barChartConfig.xAxis]);
      });

    stacked.map((ele, i) => {
      seriesData.push({
        name: ele,
        type: "bar",
        stack: "one",
        barWidth: 40,
        animation: true,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: "rgba(0,0,0,0.3)",
          },
        },
        data: nestedSeriesData[i],
      });
    });

    let isLastSlide = xAxisData && this.state.startIndex > xAxisData.length - 3;
    let thirdLastIndex = xAxisData && xAxisData.indexOf(xAxisData[xAxisData.length - 3]);
    let isNoData = !graphData || graphData.every((el) => Object.keys(el.tableData || {}).length == 0);

    return (
      <div className="chart-template chart-template--stacked-bar">
        <div
          style={{ width: "100%", cursor: "pointer" }}
          className={`reportMainContainer chart-report chart-report--stacked-bar${isNoData ? " chart-report--empty" : ""}`}
        >
          {isNoData ? (
            <ChartEmptyState graphHeight={graphHeight} variant="stacked-bar" />
          ) : (
            <ReactECharts
              option={this.getOption(
                stacked,
                xAxisData,
                seriesData,
                barChartConfig.xAxis,
                barChartConfig.barColors
              )}
              style={{ height: graphHeight, width: "108%" }}
            />
          )}
        </div>

        {xAxisData.length > 4 && (
          <div className="chart-pagination-sec">
            <div className="entries-txt">
              Showing{" "}
              {isLastSlide ? thirdLastIndex + 1 : this.state.startIndex + 1} to{" "}
              {isLastSlide
                ? xAxisData.length
                : this.state.startIndex + 3 - 1 + 1}{" "}
              of {xAxisData.length} entries
            </div>

            <div className="chart-pagination">
              <span
                role="button"
                className="pag-btn prev"
                onClick={() => this.prev()}
              >
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
              </span>
              &nbsp;
              <span
                role="button"
                className="pag-btn next"
                onClick={() => this.next(xAxisData)}
              >
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default StackedBarChartTemplate2;
